<template>
  <!--
    トグルスイッチのラッパーコンポーネント

    値はv-modelで渡し、次のように使用します。
    <gl-switch v-model="some-boolean"> text </gl-switch>
  -->
  <md-switch v-model="model" :class="classes" v-bind="$attrs">
    <slot></slot>
  </md-switch>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    primary: {
      type: Boolean,
      default: true,
    },
    accent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'md-primary': this.primary,
        'md-accent': this.accent,
      }
    },
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
